export default __webpack_public_path__ + "static/media/DGX-H200.d2a4f9ee.png";